<template>
  <div class="tag-options">
    <div class="tag-options__head">
      <strong class="mb-1">
        {{ label }}<span v-show="isRequiredField">*</span>
        <slot name="label-right"></slot>
      </strong>
      <b-dropdown variant="link" right :disabled="disabled" :popper-opts="popperOptions">
        <template slot="button-content">
          <span class="tag-options__options">{{ $t('fields.tag-options-input.options') }}</span>
        </template>
        <b-dropdown-item @click="onAddAll">
          {{ $t('fields.tag-options-input.add-all', {
              itemsToAdd: optionsCustomLabel
            })
          }}
        </b-dropdown-item>
        <b-dropdown-item @click="onRemoveAll">
          {{ $t('fields.tag-options-input.remove-all', {
              itemsToRemove: optionsCustomLabel
            })
          }}
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <s-multiselect
      :proxy-binds="{
        label: tagLabel,
        options: tags,
        trackBy: trackTagBy,
        disabled: disabled || loading,
        loading,
        openDirection: dropdownDirection,
      }"
      :proxy-events="{ remove: onRemoveItem, select: onAddItem }"
      :value="selectedItems"
    />
  </div>
</template>

<script>
import popperOptsMixin from '@/services/popperOptsMixin';

export default {
  name: 'TagOptionsInput',
  mixins: [popperOptsMixin],
  props: {
    label: {
      type: String,
      required: false,
    },
    tagLabel: {
      type: String,
      required: true,
    },
    trackTagBy: {
      type: String,
      required: true,
    },
    tags: {
      type: Array,
      default: () => ([]),
    },
    selectedItems: {
      type: Array,
      default: () => ([]),
    },
    optionsCustomLabel: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isRequiredField: {
      type: Boolean,
      default: false,
    },
    dropdownDirection: {
      type: String,
      default: '',
    },
  },
  methods: {
    onRemoveItem(itemToRemove) {
      const arrayWithoutItem = this.selectedItems.filter(item => item.id !== itemToRemove.id);
      this.$emit('update:selectedItems', arrayWithoutItem);
      this.$emit('remove-item', itemToRemove);
    },
    onAddItem(item) {
      this.$emit('update:selectedItems', [item, ...this.selectedItems]);
      this.$emit('add-item', item);
    },
    onRemoveAll() {
      this.$emit('update:selectedItems', []);
      this.$emit('remove-all');
    },
    onAddAll() {
      this.$emit('update:selectedItems', this.tags);
      this.$emit('add-all');
    },
  },
};
</script>

<style lang="sass" scoped>
  .tag-options
    &__head
      display: flex
      justify-content: space-between
      align-items: flex-end
    &__options
      font-size: .9rem
    ::v-deep
      .multiselect
        &__tag
          margin-top: .4rem
          font-size: .9rem
          font-weight: bold
        &__spinner
          height: 30px
      .dropdown-toggle.btn-link
        padding-bottom: 0
</style>
